export const LKGeneralLayoutKeys = {
  LKGeneralLayout: 'LKGeneralLayout',
}
